import React from "react";

const ExtraListShimmer = () => {
  return (
    <div className="mt-4 space-y-3 px-3 md:px-8 md:border md:border-gray-100 md:rounded-xl md:shadow-sm md:p-4">
      <div className="flex justify-between gap-4">
        {/* Item Name Skeleton */}
        <div className="h-4 w-40 shimmer rounded"></div>

        {/* Buttons Skeleton */}
        <div className="flex gap-3 justify-end">
          <div className="h-6 w-6 shimmer rounded"></div>
          <div className="h-6 w-6 shimmer rounded"></div>
          <div className="h-6 w-10 shimmer rounded"></div>
        </div>
      </div>

      {/* Price Skeleton */}
      <div>
        <div className="h-5 w-24 shimmer rounded"></div>
      </div>
    </div>
  );
};

export default ExtraListShimmer;
